exports.isMobile = function() {
  if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
    return true;
  } 
  return false;
}

exports.isLogin = () => {
  if(localStorage.getItem('accessToken') === null) {
	  return false;
	}
  return true;
}
